import { render, staticRenderFns } from "./SubCategorias.vue?vue&type=template&id=b8f6b01a&"
import script from "./SubCategorias.vue?vue&type=script&lang=js&"
export * from "./SubCategorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports